import { render, staticRenderFns } from "./InsuranceProductAdd.vue?vue&type=template&id=047af7cc&scoped=true"
import script from "./InsuranceProductAdd.vue?vue&type=script&lang=js"
export * from "./InsuranceProductAdd.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProductAdd.vue?vue&type=style&index=0&id=047af7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047af7cc",
  null
  
)

export default component.exports